import http from "../../httpService";
import { apiUrl } from "../../../../config.js";

const apiEndpoint = apiUrl + "/setup/sales/";

export function getSalesTargets() {
  return http.get(apiEndpoint + "sales-targets");
}

export function saveSalesTarget(salesTarget) {
  return httpSaveData("sales-target", salesTarget);
}

export function deleteSalesTarget(salesTargetID) {
  return http.delete(apiEndpoint + "sales-target/" + salesTargetID);
}

export function getSalesTargetDivided(salesTargetID) {
  return http.get(apiEndpoint + "sales-target-divided/" + salesTargetID);
}

export function saveSalesTargetDivided(salesTargetDivided) {
  return http.post(apiEndpoint + "sales-target-divided", salesTargetDivided);
}

export function saveSalesTargetUsers(salesTargetUsers) {
  return http.post(apiEndpoint + "sales-target-users", salesTargetUsers);
}

export function getSalesTargetUsers(salesTargetDivID) {
  return http.get(apiEndpoint + "sales-target-users/" + salesTargetDivID);
}

function httpSaveData(path, data) {
  if (data.ID === 0) {
    return http.post(apiEndpoint + path, data);
  } else {
    return http.put(apiEndpoint + path, data);
  }
}

export function getCostComponents() {
  return http.get(apiEndpoint + "cost-components");
}

export function saveCostComponent(costComponent) {
  return httpSaveData("cost-component", costComponent);
}

export function deleteCostComponent(costComponentID) {
  return http.delete(apiEndpoint + "cost-component/" + costComponentID);
}
